<template>
  <div
    v-if="!!adspotId"
    class="adspot-supplier"
  >
    <Button
      class="add-button"
      type="primary"
      icon="md-add"
      :disabled="leftSupplierList.length === 0"
      @click="add"
    >
      添加渠道设置
    </Button>
    <Form
      ref="adspotSupplierForm"
      :model="editAdspotSupplier"
      :rules="rules"
    >
      <Table
        :columns="columns"
        :data="adspotSupplierList"
        size="large"
      >
        <template
          slot="supplier"
          slot-scope="{ row: { id, supplier_id } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="supplier_id"
          >
            <Select
              v-model="editAdspotSupplier.supplier_id"
              size="large"
              :disabled="!!id"
              transfer
            >
              <Option
                v-for="(supplier, index) in allSupplierList"
                :key="index"
                :value="supplier.id"
                :label="supplier.supplier_name"
              />
            </Select>
          </FormItem>
          <p
            v-else
            v-text="getSupplierName(supplier_id)"
          />
        </template>
        <template
          slot="bottoming"
          slot-scope="{ row: { id, is_bottom } }"
        >
          <iSwitch
            v-if="editId === id"
            v-model="editAdspotSupplier.is_bottom"
            size="large"
            :disabled="!id"
            :true-value="1"
            :false-value="0"
          >
            <span slot="open">
              打开
            </span>
            <span slot="close">
              关闭
            </span>
          </iSwitch>
          <p
            v-else
            v-text="is_bottom ? '是' : '否'"
          />
        </template>
        <template
          slot="supplierAdspotId"
          slot-scope="{ row: { id, supplier_adspot_id } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="supplier_adspot_id"
          >
            <iInput
              v-model="editAdspotSupplier.supplier_adspot_id"
              size="large"
            />
          </FormItem>
          <p
            v-else
            v-text="supplier_adspot_id || '无'"
          />
        </template>
        <template
          slot="priority"
          slot-scope="{ row: { id, priority } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="priority"
          >
            <InputNumber
              v-model="editAdspotSupplier.priority"
              size="large"
              :min="1"
              :max="20"
            />
          </FormItem>
          <p
            v-else
            v-text="priority"
          />
        </template>
        <template
          slot="isHeadBidding"
          slot-scope="{ row: { id, is_head_bidding } }"
        >
          <iSwitch
            v-if="editId === id"
            v-model="editAdspotSupplier.is_head_bidding"
            size="large"
            :true-value="1"
            :false-value="0"
          >
            <span slot="open">
              打开
            </span>
            <span slot="close">
              关闭
            </span>
          </iSwitch>
          <p
            v-else
            v-text="is_head_bidding ? '打开' : '关闭'"
          />
        </template>
        <template
          slot="price"
          slot-scope="{ row: { id, price } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="price"
          >
            <InputNumber
              v-model="editAdspotSupplier.price"
              size="large"
              :min="0"
            />
          </FormItem>
          <p
            v-else
            v-text="price === null ? '无' : price"
          />
        </template>
        <template
          slot="percentage"
          slot-scope="{ row: { id, percentage } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="percentage"
          >
            <InputNumber
              v-model="editAdspotSupplier.percentage"
              size="large"
              :min="0"
              :max="100"
              :step="10"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')"
            />
          </FormItem>
          <p
            v-else
            v-text="`${percentage}%`"
          />
        </template>
        <template
          slot="timeOut"
          slot-scope="{ row: { id, time_out } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="time_out"
          >
            <InputNumber
              v-if="editId === id"
              v-model="editAdspotSupplier.time_out"
              size="large"
              :min="0"
              :step="100"
              :formatter="value => `${value} ms`"
              :parser="value => value.replace(' ms', '')"
            />
          </FormItem>
          <p
            v-else
            v-text="`${time_out} ms`"
          />
        </template>
        <template
          slot="ipWhiteList"
          slot-scope="{ row: { id, ip_white_list } }"
        >
          <div v-if="editId === id">
            <div
              v-for="(ip, index) in editAdspotSupplier.ip_white_list"
              :key="index"
            >
              <iInput
                v-if="editId === id"
                v-model="editAdspotSupplier.ip_white_list[index]"
                class="ip-input"
                :autosize="true"
                size="large"
                @keyup.enter.native="editAdspotSupplier.ip_white_list.push('')"
              >
                <Icon
                  slot="suffix"
                  class="ip-input-icon"
                  type="md-trash"
                  @click.native="editAdspotSupplier.ip_white_list.splice(index, 1)"
                />
              </iInput>
            </div>
            <Button
              class="operation add-ip"
              type="primary"
              icon="md-add"
              @click="editAdspotSupplier.ip_white_list.push('')"
            />
          </div>
          <template v-else-if="ip_white_list.length !== 0">
            <span
              v-for="(item, index) in ip_white_list"
              :key="index"
            >
              {{ item }}<br>
            </span>
          </template>
          <p v-else>
            不限
          </p>
        </template>
        <template
          slot="afterDirect"
          slot-scope="{ row: { id, after_direct } }"
        >
          <div v-if="editId === id">
            <div
              v-for="(ip, index) in editAdspotSupplier.after_direct"
              :key="index"
            >
              <iInput
                v-if="editId === id"
                v-model="editAdspotSupplier.after_direct[index]"
                class="ip-input"
                :autosize="true"
                size="large"
                @keyup.enter.native="editAdspotSupplier.after_direct.push('')"
              >
                <Icon
                  slot="suffix"
                  class="ip-input-icon"
                  type="md-trash"
                  @click.native="editAdspotSupplier.after_direct.splice(index, 1)"
                />
              </iInput>
            </div>
            <Button
              class="operation add-ip"
              type="primary"
              icon="md-add"
              @click="editAdspotSupplier.after_direct.push('')"
            />
          </div>
          <template v-else-if="after_direct.length !== 0">
            <span
              v-for="(item, index) in after_direct"
              :key="index"
            >
              {{ item }}<br>
            </span>
          </template>
          <p v-else>
            不限
          </p>
        </template>
        <template
          slot="afterDirect2"
          slot-scope="{ row: { id, after_direct2 } }"
        >
          <div v-if="editId === id">
            <div
              v-for="(ip, index) in editAdspotSupplier.after_direct2"
              :key="index"
            >
              <iInput
                v-if="editId === id"
                v-model="editAdspotSupplier.after_direct2[index]"
                class="ip-input"
                :autosize="true"
                size="large"
                @keyup.enter.native="editAdspotSupplier.after_direct2.push('')"
              >
                <Icon
                  slot="suffix"
                  class="ip-input-icon"
                  type="md-trash"
                  @click.native="editAdspotSupplier.after_direct2.splice(index, 1)"
                />
              </iInput>
            </div>
            <Button
              class="operation add-ip"
              type="primary"
              icon="md-add"
              @click="editAdspotSupplier.after_direct2.push('')"
            />
          </div>
          <template v-else-if="after_direct2.length !== 0">
            <span
              v-for="(item, index) in after_direct2"
              :key="index"
            >
              {{ item }}<br>
            </span>
          </template>
          <p v-else>
            不限
          </p>
        </template>
        <template
          slot="locationList"
          slot-scope="{ row: { id, location_list } }"
        >
          <Select
            v-if="editId === id"
            v-model="editAdspotSupplier.location_list"
            transfer
            multiple
            filterable
          >
            <OptionGroup
              v-for="(item, index) in locationList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              <Option
                v-for="(city, cityIndex) in item.city"
                :key="cityIndex"
                :label="city.name"
                :value="city.id"
              />
            </OptionGroup>
          </Select>
          <p
            v-else
            v-text="getLocationList(location_list) || '不限'"
          />
        </template>
        <template
          slot="episodeTargeting"
          slot-scope="{ row }"
        >
          <template
            v-if="editId === row.id"
          >
            <div class="episodeEditing">
              包含：
              <ButtonGroup>
                <template
                  v-for="(value, name) in episodeMapping"
                >
                  <Button
                    v-if="editAdspotSupplier.includeEpisodeType !== name"
                    :key="name"
                    @click="changeIncludeEpisodeType({ type: name })"
                    v-text="value"
                  />
                  <Button
                    v-else
                    :key="name"
                    type="primary"
                    v-text="value"
                  />
                </template>
              </ButtonGroup>
              <div class="episodeInput">
                <iInput
                  v-if="editAdspotSupplier.includeEpisodeType === 'type'"
                  v-model="editAdspotSupplier.include_episode_type_list"
                  size="large"
                  placeholder="请输入剧集类型，多个之间用逗号分隔"
                />
                <iInput
                  v-else-if="editAdspotSupplier.includeEpisodeType === 'season'"
                  v-model="editAdspotSupplier.include_episode_id_list"
                  size="large"
                  placeholder="请输入剧集ID，多个之间用逗号分隔"
                />
                <iInput
                  v-else-if="editAdspotSupplier.includeEpisodeType === 'episode'"
                  v-model="editAdspotSupplier.include_current_episode_list"
                  size="large"
                  placeholder="请输入当前集数，多个之间用逗号分隔"
                />
              </div>
            </div>
            <div class="episodeEditing">
              排除：
              <ButtonGroup>
                <template
                  v-for="(value, name) in episodeMapping"
                >
                  <Button
                    v-if="editAdspotSupplier.excludeEpisodeType !== name"
                    :key="name"
                    @click="changeExcludeEpisodeType({ type: name })"
                    v-text="value"
                  />
                  <Button
                    v-else
                    :key="name"
                    type="primary"
                    v-text="value"
                  />
                </template>
              </ButtonGroup>
              <div class="episodeInput">
                <iInput
                  v-if="editAdspotSupplier.excludeEpisodeType === 'type'"
                  v-model="editAdspotSupplier.exclude_episode_type_list"
                  size="large"
                  placeholder="请输入剧集类型，多个之间用逗号分隔"
                />
                <iInput
                  v-else-if="editAdspotSupplier.excludeEpisodeType === 'season'"
                  v-model="editAdspotSupplier.exclude_episode_id_list"
                  size="large"
                  placeholder="请输入剧集ID，多个之间用逗号分隔"
                />
                <iInput
                  v-else-if="editAdspotSupplier.excludeEpisodeType === 'episode'"
                  v-model="editAdspotSupplier.exclude_current_episode_list"
                  size="large"
                  placeholder="请输入当前集数，多个之间用逗号分隔"
                />
              </div>
            </div>
          </template>
          <p
            v-else
            v-html="getEpisodeTargetingHtml(row)"
          />
        </template>
        <template
          slot="appVersionTargeting"
          slot-scope="{ row }"
        >
          <template
            v-if="editId === row.id"
          >
            <div class="episodeEditing">
              <ButtonGroup>
                <template
                  v-for="(value, name) in appVersionTypeMapping"
                >
                  <Button
                    v-if="editAdspotSupplier.appVersionType !== name"
                    :key="name"
                    @click="changeAppVersionType({ type: name })"
                    v-text="value"
                  />
                  <Button
                    v-else
                    :key="name"
                    type="primary"
                    v-text="value"
                  />
                </template>
              </ButtonGroup>
              <div class="episodeInput">
                <iInput
                  v-if="['include', 'exclude'].indexOf(editAdspotSupplier.appVersionType) !== -1"
                  v-model="editAdspotSupplier.app_versions"
                  size="large"
                  placeholder="请填写版本号，多个之间用逗号分隔，如3.10.1，3.10.2"
                />
                <iInput
                  v-else
                  v-model="editAdspotSupplier.app_versions"
                  size="large"
                  placeholder="请填写一个版本号，如3.10.1"
                />
              </div>
            </div>
          </template>
          <p
            v-else
            v-text="getAppVersionTargeting(row)"
          />
        </template>
        <template
          slot="hotEpisodeTargeting"
          slot-scope="{ row: { id, hot_episode_type_list } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="hot_episode_type_list"
          >
            <iInput
              v-model="editAdspotSupplier.hot_episode_type_list"
              placeholder="输入热剧值，用英文逗号分隔"
              size="large"
            />
          </FormItem>
          <p
            v-else
            v-text="hot_episode_type_list || '不限'"
          />
        </template>
        <template
          slot="dailyRequestLimit"
          slot-scope="{ row: { id, daily_req_limit } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="daily_req_limit"
          >
            <InputNumber
              v-model="editAdspotSupplier.daily_req_limit"
              size="large"
              :min="0"
            />
          </FormItem>
          <p
            v-else
            v-text="daily_req_limit || '不限'"
          />
        </template>
        <template
          slot="deviceDailyRequestLimit"
          slot-scope="{ row: { id, device_daily_req_limit } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="device_daily_req_limit"
          >
            <InputNumber
              v-model="editAdspotSupplier.device_daily_req_limit"
              size="large"
              :min="0"
            />
          </FormItem>
          <p
            v-else
            v-text="device_daily_req_limit || '不限'"
          />
        </template>
        <template
          slot="deviceRequestInterval"
          slot-scope="{ row: { id, device_request_interval } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="device_request_interval"
          >
            <InputNumber
              v-model="editAdspotSupplier.device_request_interval"
              size="large"
              :min="0"
            />
          </FormItem>
          <p
            v-else
            v-text="device_request_interval || '不限'"
          />
        </template>
        <template
          slot="externalPatch"
          slot-scope="{ row: { id, show_external_patch } }"
        >
          <iSwitch
            v-if="editId === id"
            v-model="editAdspotSupplier.show_external_patch"
            size="large"
            :true-value="1"
            :false-value="0"
          >
            <span slot="open">
              展示
            </span>
            <span slot="close">
              不展示
            </span>
          </iSwitch>
          <p
            v-else
            v-text="show_external_patch ? '展示' : '不展示'"
          />
        </template>
        <template
          slot="status"
          slot-scope="{ row: { id, status } }"
        >
          <iSwitch
            v-if="editId === id"
            v-model="editAdspotSupplier.status"
            size="large"
            :true-value="1"
            :false-value="0"
          >
            <span slot="open">
              打开
            </span>
            <span slot="close">
              关闭
            </span>
          </iSwitch>
          <p
            v-else
            v-text="status ? '打开' : '关闭'"
          />
        </template>
        <template
          slot="edit"
          slot-scope="{ row }"
        >
          <div v-if="editId === row.id">
            <Button
              v-if="row.id"
              class="operation"
              type="primary"
              icon="md-checkmark"
              @click="submitEdit"
            />
            <Button
              v-else
              class="operation"
              type="primary"
              icon="md-checkmark"
              @click="submitAdd"
            />
            <Button
              v-if="row.id"
              class="operation"
              icon="md-close"
              @click="cancelEdit"
            />
            <Button
              v-else
              class="operation"
              icon="md-trash"
              @click="cancelAdd"
            />
            <Poptip
              confirm
              transfer
              title="确定要删除吗？"
              ok-text="删除"
              cancel-text="取消"
              @on-ok="deleteAdspot({ supplierId: row.id })"
            >
              <Button
                v-if="row.id"
                class="operation delete"
                type="error"
                icon="md-trash"
              />
            </Poptip>
          </div>
          <div v-else>
            <Button
              class="operation"
              icon="md-create"
              @click="edit({ adspotSupplier: Object.assign({}, row) })"
            />
          </div>
        </template>
      </Table>
    </Form>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import {
  Table,
  Button,
  ButtonGroup,
  Select,
  OptionGroup,
  Option,
  InputNumber,
  Input,
  Switch,
  Form,
  FormItem,
  Icon,
  Tooltip,
  Poptip
} from 'iview'
import locationList from '../assets/location'

export default {
  components: {
    Table,
    Button,
    ButtonGroup,
    Select,
    OptionGroup,
    Option,
    InputNumber,
    iInput: Input,
    iSwitch: Switch,
    Form,
    FormItem,
    Icon,
    Poptip
  },

  props: {
    adspot: {
      type: Object,
      required: true
    },
    userName: {
      type: String,
      required: true
    }
  },

  data () {
    var result = {
      columns: [
        { title: '渠道ID', key: 'supplier_id', width: 80, fixed: 'left' },
        { title: '渠道', slot: 'supplier', width: 130, fixed: 'left' },
        { title: '渠道广告位ID', slot: 'supplierAdspotId', width: 130, fixed: 'left' },
        {
          title: '打底',
          slot: 'bottoming',
          width: 100,
          fixed: 'left',
          renderHeader: (create, data) => create(
            Tooltip,
            {
              props: {
                placement: 'top',
                content: '同时只能有一个打底渠道',
                transfer: true
              }
            },

            [
              create(
                'p',
                {
                  style: {
                    cursor: 'help'
                  }
                },

                [
                  data.column.title,
                  create(
                    Icon,
                    {
                      props: {
                        type: 'md-help'
                      },
                      style: {
                        position: 'relative',
                        top: '-1px'
                      }
                    }
                  )
                ]
              )
            ]
          )
        },
        {
          title: '优先级',
          slot: 'priority',
          width: 120,

          renderHeader: (create, data) => create(
            Tooltip,
            {
              props: {
                placement: 'top',
                content: '数字越小，优先级越高',
                transfer: true
              }
            },

            [
              create(
                'p',
                {
                  style: {
                    cursor: 'help'
                  }
                },

                [
                  data.column.title,
                  create(
                    Icon,
                    {
                      props: {
                        type: 'md-help'
                      },
                      style: {
                        position: 'relative',
                        top: '-1px'
                      }
                    }
                  )
                ]
              )
            ]
          )
        },
        { title: '流量比例', slot: 'percentage', width: 120 },
        { title: '头部竞价', slot: 'isHeadBidding', width: 100 },
        { title: '价格(元)', slot: 'price', width: 120 },
        { title: '超时时间', slot: 'timeOut', width: 120 },
        {
          title: '前置定向',
          slot: 'ipWhiteList',
          width: 330,

          renderHeader: (create, data) => create(
            Tooltip,
            {
              props: {
                placement: 'top',
                content: '支持IP、IMEI、IDFA、OAID、Android ID',
                transfer: true
              }
            },

            [
              create(
                'p',
                {
                  style: {
                    cursor: 'help'
                  }
                },

                [
                  data.column.title,
                  create(
                    Icon,
                    {
                      props: {
                        type: 'md-help'
                      },
                      style: {
                        position: 'relative',
                        top: '-1px'
                      }
                    }
                  )
                ]
              )
            ]
          )
        },
        {
          title: '后置定向',
          slot: 'afterDirect',
          width: 330,

          renderHeader: (create, data) => create(
            Tooltip,
            {
              props: {
                placement: 'top',
                content: '支持IP、IMEI、IDFA、OAID、Android ID',
                transfer: true
              }
            },

            [
              create(
                'p',
                {
                  style: {
                    cursor: 'help'
                  }
                },

                [
                  data.column.title,
                  create(
                    Icon,
                    {
                      props: {
                        type: 'md-help'
                      },
                      style: {
                        position: 'relative',
                        top: '-1px'
                      }
                    }
                  )
                ]
              )
            ]
          )
        },
        { title: '城市定向', slot: 'locationList', minWidth: 350 },
        { title: '剧定向', slot: 'episodeTargeting', width: 310 },
        { title: '热剧定向', slot: 'hotEpisodeTargeting', width: 200 },
        { title: '新剧外贴片', slot: 'externalPatch', minWidth: 120 },
        { title: '版本定向', slot: 'appVersionTargeting', width: 305 },
        { title: '每日请求上限', slot: 'dailyRequestLimit', width: 200 },
        { title: '设备每日请求上限', slot: 'deviceDailyRequestLimit', width: 200 },
        { title: '设备请求间隔', slot: 'deviceRequestInterval', width: 200 },
        { title: '状态', slot: 'status', width: 100, fixed: 'right' },
        { title: '操作', slot: 'edit', width: 160, fixed: 'right' }
      ],

      locationList,
      locationMap: {},

      rules: {
        supplier_id: [
          { required: true, message: '请选择渠道名称' }
        ],
        priority: [
          { required: true, message: '请填写优先级' }
        ],
        percentage: [
          { required: true, message: '请填写流量比例' }
        ],
        time_out: [
          { required: true, message: '请填写超时时间' }
        ]
      },

      episodeMapping: {
        type: '剧类类型',
        season: '剧集ID',
        episode: '当前集数'
      },

      appVersionTypeMapping: {
        greater: '大于等于',
        smaller: '小于等于',
        include: '包含',
        exclude: '排除'
      }
    }
    if (!this.adspot.need_external_patch) {
      var index = result.columns.findIndex(item => item.slot === 'externalPatch')
      if (index) {
        result.columns.splice(index, 1)
      }
    }
    return result
  },

  computed: {
    ...mapState('adspotSupplier', {
      adspotSupplierList (state, getters) {
        return getters.supplierList(this.adspotId)
      },
      editAdspotSupplier (state, getters) {
        return getters.editAdspotSupplier(this.adspotId)
      },
      editId (state, getters) {
        return getters.editId(this.adspotId)
      }
    }),

    ...mapState('supplier', {
      allSupplierList: 'supplierList'
    }),

    adspotId () {
      return this.adspot.id
    },

    leftSupplierList () {
      return this.allSupplierList
        .filter(supplier => !this.adspotSupplierList
          .find(adspotSupplier => adspotSupplier.supplier_id === supplier.id))
    }
  },

  created () {
    this.init()
    this.getAllAdspotSupplier()
    if (!this.adspotSupplierList || !this.adspotSupplierList.length) {
      this.getAllSupplier()
    }
    this.initLocationMap()
  },

  methods: {
    ...mapMutations('adspotSupplier', {
      init (commit) {
        return commit('init', { adspotId: this.adspotId })
      },

      add (commit) {
        return commit('add', { adspotId: this.adspotId })
      },

      cancelAdd (commit) {
        return commit('cancelAdd', { adspotId: this.adspotId })
      },

      edit (commit, { adspotSupplier }) {
        return commit('edit', { adspotSupplier, adspotId: this.adspotId })
      },

      cancelEdit (commit) {
        return commit('cancelEdit', { adspotId: this.adspotId })
      },

      changeIncludeEpisodeType (commit, { type }) {
        return commit('changeIncludeEpisodeType', { type, adspotId: this.adspotId })
      },

      changeExcludeEpisodeType (commit, { type }) {
        return commit('changeExcludeEpisodeType', { type, adspotId: this.adspotId })
      },

      changeAppVersionType (commit, { type }) {
        return commit('changeAppVersionType', { type, adspotId: this.adspotId })
      }
    }),

    ...mapActions('adspotSupplier', {
      getAllAdspotSupplier (dispatch) {
        return dispatch('getAll', { adspotId: this.adspotId })
      },

      submitAdd (dispatch) {
        this.$refs.adspotSupplierForm.validate(isValid => {
          if (isValid) {
            dispatch('submitAdd', { adspotId: this.adspotId })
          } else {
            this.$Message.error('填写信息有误！')
          }
        })
      },

      submitEdit (dispatch) {
        this.$refs.adspotSupplierForm.validate(isValid => {
          if (isValid) {
            dispatch('submitEdit', { adspotId: this.adspotId })
          } else {
            this.$Message.error('填写信息有误！')
          }
        })
      },

      deleteAdspot (dispatch, { supplierId }) {
        return dispatch('delete', { supplierId, adspotId: this.adspotId })
      }
    }),

    ...mapActions('supplier', {
      getAllSupplier: 'getAll'
    }),

    initLocationMap () {
      locationList.forEach(item => item.city.forEach(city => {
        this.locationMap[city.id] = city.name
      }))
    },

    getSupplierName (id) {
      if (!this.allSupplierList || !this.allSupplierList.length) {
        return id
      }
      const supplier = this.allSupplierList.find(item => item.id === id)
      if (!supplier) {
        return id
      }
      return supplier.supplier_name
    },

    getLocationList (locationList) {
      return locationList.map(item => this.locationMap[item])
        .filter(item => item)
        .join(', ')
    },

    getEpisodeTargetingHtml (adspotSupplier) {
      var includeValue = adspotSupplier.include_episode_type_list ||
        adspotSupplier.include_episode_id_list ||
        adspotSupplier.include_current_episode_list
      var excludeValue = adspotSupplier.exclude_episode_type_list ||
        adspotSupplier.exclude_episode_id_list ||
        adspotSupplier.exclude_current_episode_list
      var result = []

      if (includeValue) {
        var includeFiledName = this.episodeMapping[adspotSupplier.includeEpisodeType]
        result.push(`包含 ${includeFiledName || ''}：${includeValue}`)
      }
      if (excludeValue) {
        var excludeFieldName = this.episodeMapping[adspotSupplier.excludeEpisodeType]
        result.push(`排除 ${excludeFieldName || ''}：${excludeValue}`)
      }

      if (!result.length) {
        return '不限'
      }

      return result.join('<br>')
    },

    getAppVersionTargeting (adspotSupplier) {
      if (!adspotSupplier.app_versions || !adspotSupplier.appVersionType) {
        return '不限'
      }

      var appOperatorMap = {
        greater: '大于等于',
        smaller: '小于等于',
        include: '包含',
        exclude: '排除'
      }
      return appOperatorMap[adspotSupplier.appVersionType] + adspotSupplier.app_versions
    }
  }
}
</script>

<style lang="less" scoped>
.add-button {
  margin-bottom: 10px;
}
button.operation {
  margin-right: 5px;
  padding: 0;
  width: 33px;
  height: 33px;
  font-size: 16px;

  &:last-child {
    margin-right: 0;
  }

  &.delete {
    margin-left: 15px;
  }
}
.add-ip {
  margin-top: 3px;
}
.ip-input {
  margin-bottom: 5px;
}
.ip-input-icon:hover {
  color: #ed4014;
}
.form-item {
  margin-top: 24px;
}
.episodeEditing {
  margin: 20px 0;
}
.episodeInput {
  margin-top: 10px;
}
</style>
